import React, { useState, useEffect } from 'react';
import { adminFetch } from '../../api/client';

const API_URL = process.env.REACT_APP_API_URL || '';

const MatchesTab = ({ user }) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [week, setWeek] = useState('');
  const [total, setTotal] = useState(0);

  const fetchMatches = async (targetWeek) => {
    setLoading(true);
    try {
      const url = targetWeek
        ? `${API_URL}/api/admin/matches/current?week=${targetWeek}`
        : `${API_URL}/api/admin/matches/current`;
      const res = await adminFetch(url);
      const data = await res.json();
      if (data.success) {
        setMatches(data.matches);
        setTotal(data.total);
        setWeek(data.week);
      }
    } catch (err) {
      console.error('Matches fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMatches(); }, [user]);

  const navigateWeek = (dir) => {
    const d = new Date(week);
    d.setDate(d.getDate() + dir * 7);
    const w = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    fetchMatches(w);
  };

  // Stats
  const byPool = {};
  const feedbackStats = { met: 0, scheduled: 0, failed: 0, pending: 0 };
  matches.forEach(m => {
    const pool = m.community?.name || 'Global';
    byPool[pool] = (byPool[pool] || 0) + 1;
    ['we_met_1', 'we_met_2'].forEach(f => {
      const v = m[f];
      if (v === 'Met') feedbackStats.met++;
      else if (v === 'Scheduled') feedbackStats.scheduled++;
      else if (v === 'Fail' || v === 'No') feedbackStats.failed++;
      else feedbackStats.pending++;
    });
  });

  if (loading) return <p style={{ color: '#9ca3af', padding: '24px' }}>Loading matches...</p>;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <button onClick={() => navigateWeek(-1)} style={navBtnStyle}>&larr; Prev</button>
        <span style={{ fontWeight: 600, fontSize: '16px' }}>Week: {week}</span>
        <button onClick={() => navigateWeek(1)} style={navBtnStyle}>Next &rarr;</button>
        <span style={{ color: '#6b7280', marginLeft: 'auto' }}>{total} matches</span>
      </div>

      {/* Stats bar */}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
        {Object.entries(byPool).map(([pool, count]) => (
          <div key={pool} style={statCardStyle}>
            <div style={{ fontSize: '20px', fontWeight: 700 }}>{count}</div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>{pool}</div>
          </div>
        ))}
        <div style={{ ...statCardStyle, borderColor: '#10b981' }}>
          <div style={{ fontSize: '20px', fontWeight: 700, color: '#10b981' }}>{feedbackStats.met}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Met</div>
        </div>
        <div style={{ ...statCardStyle, borderColor: '#f59e0b' }}>
          <div style={{ fontSize: '20px', fontWeight: 700, color: '#f59e0b' }}>{feedbackStats.scheduled}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Scheduled</div>
        </div>
        <div style={{ ...statCardStyle, borderColor: '#ef4444' }}>
          <div style={{ fontSize: '20px', fontWeight: 700, color: '#ef4444' }}>{feedbackStats.failed}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Failed</div>
        </div>
      </div>

      {matches.length === 0 ? (
        <p style={{ color: '#6b7280', textAlign: 'center', padding: '24px' }}>No matches for this week</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin2-table">
            <thead>
              <tr>
                <th>Member 1</th>
                <th>Member 2</th>
                <th>Pool</th>
                <th>Status</th>
                <th>Notif</th>
                <th>Midweek</th>
                <th>Met 1</th>
                <th>Met 2</th>
                <th>FB1</th>
                <th>FB2</th>
              </tr>
            </thead>
            <tbody>
              {matches.map(m => (
                <tr key={m.airtable_id}>
                  <td>
                    <div style={{ fontWeight: 500 }}>{m.member1?.name} {m.member1?.family || ''}</div>
                    <div style={{ fontSize: '11px', color: '#9ca3af' }}>@{m.member1?.tg_username || '?'}</div>
                  </td>
                  <td>
                    <div style={{ fontWeight: 500 }}>{m.member2?.name} {m.member2?.family || ''}</div>
                    <div style={{ fontSize: '11px', color: '#9ca3af' }}>@{m.member2?.tg_username || '?'}</div>
                  </td>
                  <td style={{ fontSize: '12px' }}>{m.community?.name || 'Global'}</td>
                  <td style={{ fontSize: '12px' }}>{m.status}</td>
                  <td style={{ fontSize: '12px' }}>{m.notifications}</td>
                  <td>{m.midweek_checkin ? '✓' : '—'}</td>
                  <td><MetBadge value={m.we_met_1} /></td>
                  <td><MetBadge value={m.we_met_2} /></td>
                  <td>{m.feedback1 || '—'}</td>
                  <td>{m.feedback2 || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const MetBadge = ({ value }) => {
  if (!value) return <span style={{ color: '#d1d5db' }}>—</span>;
  const colors = { Met: '#10b981', Scheduled: '#f59e0b', Fail: '#ef4444', No: '#ef4444' };
  return (
    <span style={{ color: colors[value] || '#6b7280', fontWeight: 500, fontSize: '12px' }}>
      {value}
    </span>
  );
};

const navBtnStyle = {
  padding: '6px 14px', borderRadius: '6px', border: '1px solid #d1d5db',
  background: 'white', cursor: 'pointer', fontSize: '13px',
};

const statCardStyle = {
  padding: '12px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
  background: 'white', textAlign: 'center', minWidth: '70px',
};

export default MatchesTab;
